// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b9-4";
export var closeButton = "_b9-6";
export var dismissButton = "_b9-3";
export var editImageWithAiContainer = "_b9-8";
export var imageUploadWrapper = "_b9-7";
export var misspelledWord = "_b9-5";
export var spellCheckContainer = "_b9-2";
export var spin = "_b9-1";
export var spinning = "_b9-0";